export default {
  saveSeatObj (state, payload) {
    state.seatObj = payload
  }
}